<template>
    <div class="wrap">
        <listHeader
            :title="postData.eid > 0 ? '编辑企业' : '新增企业'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="enterprise"
                active="info"
                :eid="postData.eid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="企业名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入企业名称" v-decorator="['ename', {rules: [{ required: true, max: 64, message: '请输入企业名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="合同开始"
                                v-bind="formItemLayout"
                                v-if="!postData.eid"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择合同开始日期"
                                    v-decorator="['scontract',{rules: [{ required: false, message: '请选择合同开始日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="合同结束"
                                v-bind="formItemLayout"
                                v-if="!postData.eid"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择合同结束日期"
                                    v-decorator="['econtract',{rules: [{ required: false, message: '请选择合同结束日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab
    },
    data() {
        return {
            scenario: 'enterpriseCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'eid': '',
                'ename': '',
                'scontract': '',
                'econtract': '',
            },
            data: {},
            config: {},
            dateFormat: 'YYYY-MM-DD',
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/enterprise/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.eid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            ename: res.data.ename,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.eid > 0) {
                            url = '/manage/enterprise/edit';

                            values.eid = this.postData.eid;
                        } else {
                            url = '/manage/enterprise/save';

                            values.scontract = values.scontract ? values.scontract.format(this.dateFormat) : '';
                            values.econtract = values.econtract ? values.econtract.format(this.dateFormat) : '';
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.eid == 0) {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
